module.exports = __webpack_public_path__ + "img/restauranteingang.f00637e6.jpg";